import { render, staticRenderFns } from "./IntroSlide.vue?vue&type=template&id=bcb97850&scoped=true&"
import script from "./IntroSlide.vue?vue&type=script&lang=js&"
export * from "./IntroSlide.vue?vue&type=script&lang=js&"
import style0 from "./IntroSlide.vue?vue&type=style&index=0&id=bcb97850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb97850",
  null
  
)

export default component.exports